import React, { Component } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import './style.css';


class CountryUsers extends Component {
  
  constructor(props){
    super(props)
    this.state={
        country : "",
    };
    
  
  }
  getUsers(countryData){
  this.props.getUsers(countryData);
  }

  render(){
    let countryList="";
    if(this.props.countryCountSuccess){
     
      let countryItem = "";
      if(this.props.countryCountData && this.props.countryCountData.length){
        let countries = this.props.countryCountData;
        countryList = Object.keys(countries).map((item, index) => {
        countryItem = countries[item];

        if(countryItem.is_new > 0){
          if(countryItem.name !== null && countryItem.name !== ""){
            return   <div  key={index}>
                      <button style={{background:"#EF5350",color:"#ffffff"}} className = "catBox applyCssUserNew" onClick={this.getUsers.bind(this,countryItem)}>
                          {countryItem.name}<br/><br/>
                          {countryItem.totalUsers}
                        </button>
                    </div>
          }
        }else{
          if(countryItem.name !== null && countryItem.name !== ""){
            return   <div  key={index}>
                      <button className = "catBox applyCssUserNew" onClick={this.getUsers.bind(this,countryItem)}>
                          {countryItem.name}<br/><br/>
                          {countryItem.totalUsers}
                        </button>
                    </div>
          }
        }

          
        });
      }
    }

    return (
      <div className = "dashboardback">
        <div className = "whiteback">
        <div className = "catheading"><h1>Country Wise Users</h1></div>
        
        <div className = "containerform">
          {countryList}
          </div>
         
        
        {/* <SweetAlert
            show={this.state.show}
        title={<span> <h5>{this.state.responseMessage}</h5></span>}
            text="hello"
            confirmBtnBsStyle="default"
            onConfirm={() => this.setState({ show: false })}
        /> */}

        </div><br/>
        </div>
      
    );
  }
}
export default CountryUsers;



// WEBPACK FOOTER //
// ./src/components/country/index.js